export default {
  "地区选择": "地区选择",
  "请补全服务地区信息": "请补全服务地区信息",
  "请输入需要识别的文本": "请输入需要识别的文本",
  "请选择": "请选择",
  "识别": "识别",
  "粘贴文本至此处，可自动识别地址信息": "粘贴文本至此处，可自动识别地址信息"
}
